import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 */
import { UPDATE_PATH, UPDATE_HISTORY, LOCATION_CHANGE, RESET_IMPRESSONS, IMPRESSION_REPORTED } from './actions';
import { PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW } from '../shared/actions/impressions';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    preventPageviewReset: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case IMPRESSION_REPORTED:
      return _objectSpread({}, state, _defineProperty({}, action.elementId, action.eventData || true));

    case PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW:
      return _objectSpread({}, state, {
        preventPageviewReset: true
      });

    case RESET_IMPRESSONS:
    case UPDATE_HISTORY:
    case LOCATION_CHANGE:
    case UPDATE_PATH:
      // Manually prevent reset for navigation that doesn't warrant a new pageview
      if (state.preventPageviewReset) {
        return state;
      } // Impressions are tied to a pageview, so in-app transition should
      // let all impressions occur again


      return {};

    default:
      return state;
  }
});